import React from 'react';
import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import PageHero from '../ui/pageHero/PageHero';
import CtaSection from '../sections/home/cta/CtaSection';
import { fadeUp, stagger, viewportOnce } from '../../styles/animations';

const services = [
    {
        index: '01',
        title: 'Digital Strategy',
        summary: 'Digital products and transformation strategies aligned with your business goals.',
        points: [
            'Technology roadmaps tied to measurable business outcomes',
            'Portfolio assessments — what to build, buy, or retire',
            'Operating model design for teams shipping digital products',
        ],
    },
    {
        index: '02',
        title: 'Software Engineering',
        summary: 'Scalable digital solutions built for long-term growth.',
        points: [
            'Product engineering from architecture through delivery',
            'Legacy modernization without stopping the business',
            'Platform teams and internal tooling that compound over time',
        ],
    },
    {
        index: '03',
        title: 'Cloud & Infrastructure',
        summary: 'Modern cloud architectures designed for performance and reliability.',
        points: [
            'Cloud migration and multi-region infrastructure design',
            'Reliability engineering — observability, on-call, incident response',
            'Cost and performance optimization for infrastructure at scale',
        ],
    },
];

const ServicesPage = () => (
    <>
        <PageHero
            eyebrow="Services"
            title="What we do"
            subtitle="Three disciplines, one throughline: technology decisions that hold up under scrutiny and pressure."
        />

        <Box component="section" sx={{ backgroundColor: 'background.default', py: { xs: 8, md: 14 }, px: '6%' }}>
            <Box sx={{ maxWidth: '1400px', margin: '0 auto', display: 'flex', flexDirection: 'column', gap: { xs: 8, md: 12 } }}>
                {services.map((s, i) => (
                    <motion.div
                        key={s.title}
                        initial="hidden"
                        whileInView="visible"
                        viewport={viewportOnce}
                        variants={stagger(0.1)}
                    >
                        <Box
                            sx={{
                                display: 'grid',
                                gridTemplateColumns: { xs: '1fr', md: '1fr 2fr' },
                                gap: { xs: 3, md: 8 },
                                borderTop: '1px solid',
                                borderColor: 'divider',
                                pt: 5,
                            }}
                        >
                            <motion.div variants={fadeUp}>
                                <Typography variant="overline" sx={{ color: 'primary.main' }}>{s.index}</Typography>
                                <Typography variant="h2">{s.title}</Typography>
                            </motion.div>
                            <motion.div variants={fadeUp}>
                                <Typography variant="body1" sx={{ maxWidth: 560, mb: 3 }}>
                                    {s.summary}
                                </Typography>
                                <Box component="ul" sx={{ m: 0, pl: 3, display: 'flex', flexDirection: 'column', gap: 1 }}>
                                    {s.points.map((point) => (
                                        <Typography key={point} component="li" variant="body2" color="text.secondary">
                                            {point}
                                        </Typography>
                                    ))}
                                </Box>
                            </motion.div>
                        </Box>
                    </motion.div>
                ))}
            </Box>
        </Box>

        <CtaSection />
    </>
);

export default ServicesPage;
